import { booleanAttribute, ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MboIconButtonDirective } from '@bo-ui/material/button';
import { MboIconDirective, MboIconSize } from '@bo-ui/material/icon';

import { DialogSize } from './models/dialog-size.type';
import { DialogType } from './models/dialog-type.type';

@Component({
  selector: 'crm-tgbot-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
  host: {
    '[class]': '"crm-tgbot-dialog_" + dialogType()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatIconButton,
    MatIcon,
    MboIconButtonDirective,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MboIconDirective,
  ],
})
export class DialogComponent {
  caption = input<string>();

  shouldShowCloseButton = input(true, {
    transform: booleanAttribute,
  });

  size = input<DialogSize>('m');

  iconSize = input<MboIconSize>('m');

  dialogType = input<DialogType>('default');

  closeDialog = output<void>();
}
